// extracted by mini-css-extract-plugin
export var container = "index-module--container--63clH";
export var dl = "index-module--dl--zDpP0";
export var frontImage = "index-module--frontImage--hbUmn";
export var gradBorder = "index-module--gradBorder--Pzjl0";
export var pricingBox = "index-module--pricingBox--wX8yL";
export var pricingText = "index-module--pricingText--3OxAc";
export var subtext = "index-module--subtext--ADNtR";
export var title = "index-module--title--0Uv1b";
export var tts = "index-module--tts--uZdZv";
export var ttsContainer = "index-module--ttsContainer--K+Lb1";